import { render } from "./Maintenance.vue?vue&type=template&id=2c6c4ca0&ts=true"
import script from "./Maintenance.vue?vue&type=script&lang=ts"
export * from "./Maintenance.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__